import React from "react";
import { withStyles } from "@material-ui/core/styles";
import FormLayout from "layouts/FormLayout";
import NotificationsForm from './Forms/NotificationsForm'
import { CircularProgress } from "components/UI/Progress";

const styles = () => ({
  root: {
    flexGrow: 1,
  }
});

class NotificationsFormView extends React.PureComponent {
  render() {
    const { classes, isLoading, isEditing } = this.props;

    if (isLoading) return <CircularProgress />

    return (
      <div className={classes.root}>
        <FormLayout isEditing={isEditing} moduleName={"notifications"}>
          <NotificationsForm {...this.props} />
        </FormLayout>
      </div>
    );
  }
}

NotificationsFormView.defaultProps = {
  isEditing: false,
};

export default withStyles(styles)(NotificationsFormView);
